/**
 * Product Card Slider Initialization
 * 
 * This script initializes Splide sliders for product cards with autoplay
 */
if (!window.ProductCardSlider) {
  class ProductCardSlider {
    constructor() {
      this.sliders = [];
      this.init();
    }

    init() {
      // Initialize on page load
      this.initAllSliders();

      // Re-initialize on Shopify section loads
      document.addEventListener('shopify:section:load', () => {
        this.initAllSliders();
      });

      // Re-initialize when variants change
      document.addEventListener('variant:change', () => {
        this.initAllSliders();
      });
    }

    initAllSliders() {
      // Find all product card carousels
      const carousels = document.querySelectorAll('.card-product-carousel');
      
      if (!carousels.length) return;
      
      // Check if Splide is available
      if (typeof Splide === 'undefined') {
        console.error('Splide library not loaded yet');
        // Try again in a moment
        setTimeout(() => this.initAllSliders(), 500);
        return;
      }

      // Initialize each carousel
      carousels.forEach((carousel) => {
        // Skip if already initialized
        if (carousel.hasAttribute('data-initialized')) return;
        
        try {
          // Create new Splide instance
          const splide = new Splide(carousel, {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            pagination: true,
            arrows: false, // Remove arrows
            rewind: true,
            speed: 300,
            drag: true,
            swipe: true,
            lazyLoad: 'nearby',
            autoplay: true, // Enable autoplay
            interval: 2000, // Set interval to 2 seconds
            pauseOnHover: true,
            pauseOnFocus: true
          });
          
          // Mount the slider
          splide.mount();
          
          // Mark as initialized
          carousel.setAttribute('data-initialized', 'true');
          
          // Store reference for potential cleanup
          this.sliders.push(splide);
          
        } catch (error) {
          console.error(`Error initializing product card carousel: ${carousel.id}`, error);
        }
      });
    }
  }

  // Store the class in the window object to prevent redeclaration
  window.ProductCardSlider = ProductCardSlider;

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.productCardSlider) {
      window.productCardSlider = new ProductCardSlider();
    }
  });
} else {
  console.warn('ProductCardSlider class has already been declared.');
}


